import axios from 'axios'

class API {
  constructor () {
    this.instance = axios.create({
      baseURL: 'https://liveresultat.orientering.se/'
    })
    this.instance.defaults.headers.post['Content-Type'] = 'application/json'
  }

  async fetchEvent (competitionId) {
    const res = await this.instance.get(`api.php?method=getclasses&comp=${competitionId}`)
    return res
  }

  async fetchCategory(competitionId, category, hash) {
    let url = `api.php?method=getclassresults&comp=${competitionId}&class=${category}&unformattedTimes=true`
    if (hash) {
      url += `&last_hash=${hash}`
    }
    const res = await this.instance.get(url)
    return res
  }
}

export default new API()
